'use client'
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, useRef } from 'react'
import { usePostHog } from 'posthog-js/react'
import { IClientState } from '@/config/clients'
import { isCommonCorprate } from '@/utils/validations/ValidateCoverage'

export default function PostHogPageView({ client }: { client: IClientState }): null {
	const pathname = usePathname()
	const searchParams = useSearchParams()
	const posthog = usePostHog()
	const previousPath = useRef<string | null>(null)

	useEffect(() => {
		if (isCommonCorprate(client)) return
		if (!posthog || !pathname) return

		const currentPath = `${pathname}?${searchParams.toString()}`

		// Esto evita que se envíe el evento de pageview si la URL no ha cambiado
		if (previousPath.current === currentPath) return
		previousPath.current = currentPath

		const url = window.location.href

		posthog.capture('$pageview', {
			'$current_url': url,
			'$pathname': pathname,
		})
	}, [pathname, searchParams, posthog])

	return null
}
